export default __webpack_public_path__ + "static/media/youtube.44391722.svg";